import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { LandingPage } from './pages/LandingPage';
import { Dashboard } from './pages/Dashboard';
import { ContractReview } from './pages/ContractReview';
import { LegalQuestions } from './pages/LegalQuestions';
import { GenerateWill } from './pages/GenerateWill';
import { GenerateBillOfSale } from './pages/GenerateBillOfSale';
import { LegalLetters } from './pages/LegalLetters';
import { LegalGlossary } from './pages/LegalGlossary';
import { DeadlineCalculator } from './pages/DeadlineCalculator';
import { SmallClaims } from './pages/SmallClaims';
import { NameChange } from './pages/NameChange';
import { TenantRights } from './pages/TenantRights';
import { EmploymentAdvisor } from './pages/EmploymentAdvisor';
import { ContractNegotiation } from './pages/ContractNegotiation';
import { AIAdvisor } from './pages/AIAdvisor';
import { BusinessFormation } from './pages/BusinessFormation';
import { TrademarkSearch } from './pages/TrademarkSearch';
import { BusinessContracts } from './pages/BusinessContracts';
import { MainLayout } from './components/layout/MainLayout';
import { useThemeStore } from './store/themeStore';

// Theme manager component that respects landing page light theme requirement
function ThemeManager() {
  const theme = useThemeStore((state) => state.theme);
  const location = useLocation();

  // Apply theme class to html element, but force light theme on landing page
  React.useEffect(() => {
    const isLandingPage = location.pathname === '/' || location.pathname === '/login';

    if (isLandingPage) {
      // Always force light theme on landing page
      document.documentElement.classList.remove('dark');
    } else if (theme === 'dark') {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }, [theme, location.pathname]);

  return null;
}

function App() {
  return (
    <BrowserRouter>
      <ThemeManager />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/login" element={<LandingPage />} />

        <Route element={<MainLayout />}>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/review-contract" element={<ContractReview />} />
          <Route path="/legal-questions" element={<LegalQuestions />} />
          <Route path="/generate-will" element={<GenerateWill />} />
          <Route path="/generate-bill-of-sale" element={<GenerateBillOfSale />} />
          <Route path="/legal-letters" element={<LegalLetters />} />
          <Route path="/legal-glossary" element={<LegalGlossary />} />
          <Route path="/deadline-calculator" element={<DeadlineCalculator />} />
          <Route path="/small-claims" element={<SmallClaims />} />
          <Route path="/name-change" element={<NameChange />} />
          <Route path="/tenant-rights" element={<TenantRights />} />
          <Route path="/employment-advisor" element={<EmploymentAdvisor />} />
          <Route path="/contract-negotiation" element={<ContractNegotiation />} />
          <Route path="/ai-advisor" element={<AIAdvisor />} />
          <Route path="/business-formation" element={<BusinessFormation />} />
          <Route path="/trademark-search" element={<TrademarkSearch />} />
          <Route path="/business-contracts" element={<BusinessContracts />} />
          <Route path="/account" element={<Dashboard />} />
          <Route path="/activity/:id" element={<Dashboard />} />
        </Route>

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
